import {useTitle} from 'hooks';

interface INotFoundProps {}

const NotFound = ({}: INotFoundProps) => {
  useTitle('Error 404');
  return (
    <section className="flex flex-col justify-center items-center w-screen h-screen p-3 pb-48 select-none">
      <p className="text-center text-[#34bb78] text-[140px] md:text-[152px] font-bold -mb-6">404</p>
      <p className="text-center text-slate-800 text-xl md:text-2xl font-semibold mb-3">Oops! That page doesn't exist.</p>
      <p className="text-center text-slate-700 text-lg mb-6">But dont worry, you can find plenty of other things on our homepage.</p>
      <a href="https://das-ar.com" className="border border-slate-700 p-4 rounded-full transition duration-200 hover:bg-slate-100">
        Back to Homepage
      </a>
    </section>
  );
};

export default NotFound;
